
const Article = ({ data }) => {

    return (
        <div className="w-full  flex justify-between bg-lightlavender bg-cover mt-20 md:mt-[120px]">

                <div className="2xl:container h-fit mx-auto md:px-14 lg:px-20 flex lg:flex-row gap-x-[90px] gap-y-20  items-center flex-col lg:justify-between px-6 py-[72px] md:py-20">
                    <img className='md:w-[60%] lg:w-[40%] h-fit max-sm:w-full'
                        src={process.env.PUBLIC_URL + "/images/Allproducts/xpertxpress/article.png"}
                        alt="img"
                    />
                    <div className="flex flex-col text-left gap-8">
                        <div>
                            <h2 className="text-primarycolor text-24 sm:text-32 md:text-48 font-bold">
                                {data.title}
                            </h2>
                            <p className="font-regular pt-4 text-16 sm:text-18 text-secondaryblack">{data.desc}</p>
                        </div>
                        <div className="flex flex-col gap-4">
                            {data.content.map((para, ind) => (
                                <p key={ind} className=" text-16 sm:text-18 text-left font-medium text-primarycolor flex gap-4 ">
                                    <img
                                        src={process.env.PUBLIC_URL + "/images/Allproducts/xpertxpress/features/tick2.svg"}
                                        alt="icon"
                                    />
                                    <span className="font-medium text-primarycolor">{para}</span>
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
        </div>
    )
}
export default Article;